<template>
  <div class="page-container appstore_wrap">
    <!-- <div>
      <div class="section rights-require-wrap bgf">
        <div class="w1200">
          <div class="hd">
            <h2>Rainstore 产品特性</h2>
          </div>
          <div class="bd">
            <div class="tabs-wrap">
              <div class="tab-content">
                <div class="panel-box">
                  <table class="table-4-col">
                    <th id></th>
                    <tbody>
                      <template v-for="(item, ind) in features">
                        <tr v-if="!isAn || ind < 6" :key="item.key">
                          <td class="name col-1">
                            <div>{{ item.name }}</div>
                          </td>

                          <td class="col-2">
                            <div>
                              <span v-if="item.value">{{ item.value }}</span>
                              <img
                                v-else
                                src="//img.alicdn.com/tfs/TB1hrmiSXXXXXbdXpXXXXXXXXXX-52-44.png"
                              />
                            </div>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>

                  <div
                    class="more-info-btn"
                    v-if="features.length >= 7"
                    @click="isAn = !isAn"
                    style="display: block;"
                  >
                    {{ isAn ? "展开全部" : "点击收起" }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <div class="section detail-plan-wrap" id="markets">
      <div class="w1200">
        <div class="hd">
          <h2>ISV应用商店推荐</h2>
        </div>
        <div class="bd">
          <div class="plan-box">
            <dl class="item" v-for="item in markets" :key="item.domain">
              <dt :class="activeShow == 'rainbond' ? 'active' : ''">
                <div class="head-info">
                  <img
                    class="icon def"
                    src="https://img.alicdn.com/tfs/TB1u93CRVXXXXc7XVXXXXXXXXXX-92-92.png"
                  />
                  <h3>{{ item.name }}</h3>
                  <p>
                    {{ item.description }}
                  </p>
                </div>
                <router-link
                  :to="{
                    name: 'appstore',
                    params: { marketID: item.domain }
                  }"
                  class="join-btn action dn-btn dn-btn-ghost dn-btn-light"
                  >访问</router-link
                >
              </dt>
            </dl>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getMarketList } from '@/api/index';
export default {
  name: 'Index',
  data() {
    return {
      activeShow: '',
      features: [
        {
          key: '1',
          name: '免费开店'
        },
        {
          key: '2',
          name: '客户在线转化支撑'
        },
        {
          key: '3',
          name: 'SaaS应用孵化器'
        },
        {
          key: '4',
          name: '应用在线销售'
        },
        {
          key: '5',
          name: '应用多模式自动交付'
        },
        {
          key: '6',
          name: '应用私有化定制交付'
        },
        {
          key: '7',
          name: '客户管理，在线售后'
        },
        {
          key: '8',
          name: '私有化部署，构建行业云生态'
        },
        {
          key: '9',
          name: '云边协同与端管理'
        }
      ],
      isAn: true,
      markets: [
        {
          domain: 'rainbond',
          name: 'Rainbond 开源应用商店',
          description:
            'Rainbond 社区开源商店主要为Rainbond开源用户提供应用分发和交付服务'
        },
        {
          domain: 'clouddemo',
          name: '工业互联网应用商店',
          description:
            '汇集工业制造行业优秀的产品和解决方案，提供工业行业应用商店范例'
        },
        {
          domain: 'sefonsoft',
          name: '成都四方伟业应用商店',
          description: '领先的大数据、人工智能产品及服务提供商。'
        }
      ],
      info: null
    };
  },
  methods: {
    setActiveStore(store) {
      if (this.activeShow == store) {
        this.activeShow = '';
      } else {
        this.activeShow = store;
      }
    },
    loadIndexMarkets() {
      getMarketList({ limit: 100 }).then((markets) => {
        this.markets = markets;
      });
    }
  },
  created() {
    this.loadIndexMarkets();
  },
  computed: {
    defaultMarketDomain() {
      return this.$store.state.user.platformInfo.defaultMarketDomain;
    }
  }
};
</script>

<style lang="scss" scoped>
ol,
ul,
dl {
  margin: 0;
}
.dn-btn {
  margin: 0;
  height: 32px;
  padding: 0 24px;
  font-size: 12px;
  line-height: 30px;
  border-width: 1px;
}

.bgf {
  background: #fff;
}
.rights-require-wrap {
  padding-top: 120px;
  .tabs-wrap {
    margin: 0 10px;
    .tab-nav {
      width: 205px;
      margin: 0 auto 50px;
      *zoom: 1;
      &:before {
        content: '';
        display: table;
      }
      .active {
        color: #fff;
        background: #409eff;
        border-color: #409eff;
        z-index: 2;
      }
      a {
        position: relative;
        float: left;
        line-height: 36px;
        width: 100px;
        text-align: center;
        text-decoration: none;
        font-size: 14px;
        color: #373d41;
        background: #fff;
        border: 1px solid #d7d8d9;
      }
    }
  }

  .panel-box {
    background: #fff;
    border: 1px solid #d7d8d9;
    box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.15);
    table {
      width: 100%;

      td,
      th {
        width: 25%;
      }
      tr:hover {
        background: #f8f8f9;
      }
      th {
        position: relative;
        font-size: 18px;
        color: #666;
        text-align: center;
        font-weight: 400;
        border-bottom: 1px solid #f8f8f9;
        box-sizing: border-box;
        & > div {
          width: 100%;
          height: 100px;
          line-height: 130px;
          box-sizing: border-box;
          position: relative;
        }
        .icon {
          position: absolute;
          top: -18px;
          left: 50%;
          transform: translateX(-50%);
          width: 64px;
          height: 64px;
        }
      }
      .name {
        text-align: left;
      }
      td {
        text-align: center;
        font-size: 14px;
        color: #373d41;
        border-bottom: 1px solid #f8f8f9;
        box-sizing: border-box;
        & > div {
          width: 100%;
          height: 68px;
          line-height: 68px;
          text-align: center;
          box-sizing: border-box;
          position: relative;
          img {
            width: 26px;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }
    }
    .more-info-btn {
      display: none;
      padding: 20px 0;
      font-size: 14px;
      color: #409eff;
      text-align: center;
      cursor: pointer;
    }
  }
  .hidden {
    display: none;
  }
}
.section {
  padding: 80px 0;
  .w1200 {
    width: 1200px;
    margin: 0 auto;
  }
  .hd {
    margin-bottom: 40px;
    text-align: center;
    h2 {
      font-size: 24px;
      color: #373d41;
    }
  }
  .bd {
    position: relative;
    *zoom: 1;
    &:before {
      content: '';
      display: table;
    }
    &:after {
      clear: both;
    }
  }
}
.plan-box {
  position: relative;
  margin: 0 10px;
  background: #fff;
  border: 1px solid #d7d8d9;
  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.15);
  .item {
    &:hover {
      box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.15);
    }
    border-bottom: 1px solid #d5d5d6;
    .active {
      background: #409eff;
      h3,
      p {
        color: #fff;
      }
      .join-btn {
        color: #fff;
        background-color: transparent;
        border: 1px solid #fff;
      }
    }
    dt {
      position: relative;
      height: 96px;
      cursor: pointer;
      h3 {
        font-size: 18px;
        color: #373d41;
        line-height: 24px;
        font-weight: 700;
        margin-bottom: 0;
      }
      p {
        font-size: 14px;
        color: #606468;
        line-height: 24px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .head-info {
        padding: 25px 200px 0 100px;
      }
      .join-btn {
        position: absolute;
        right: 40px;
        top: 30px;
        border: 1px solid #409eff;
        color: #409eff;
        &:hover {
          color: #fff;
          background: #409eff;
          border-color: #409eff;
        }
      }
      .icon {
        position: absolute;
        left: 25px;
        top: 23px;
        width: 50px;
      }
      .def {
        display: block;
      }
      .hover {
        display: none;
      }
    }
    dd {
      padding: 30px 100px;
      background: #f5f5f6;
      .intr {
        margin-bottom: 5px;
        font-size: 14px;
        color: #606468;
      }
      .more {
        margin-bottom: 20px;
      }
      span {
        font-weight: 700;
        font-size: 14px;
        color: #5f6367;
      }
      li {
        font-size: 14px;
        color: #606468;
        line-height: 24px;
      }
    }
  }
}
.detail-plan-wrap {
  background: #f5f5f6;
}
</style>



// WEBPACK FOOTER //
// src/views/index/components/introduceRainstore.vue